<section class="assistant-store-view" *ngIf="vm.assistantStoreView() === 'market'">
  <div class="store-toolbar">
    <nz-select
      [ngModel]="vm.marketCategory()"
      (ngModelChange)="vm.updateMarketCategory($event)"
      class="store-category-select"
      testId="assistant-market-category-select"
    >
      <nz-option
        *ngFor="let category of vm.marketCategories()"
        [nzValue]="category"
        [nzLabel]="category === 'All' ? ('assistant.management.store.filter.category.all' | i18n) : category"
      />
    </nz-select>
    <nz-input-group nzPrefixIcon="search" class="store-search-input">
      <input
        nz-input
        [ngModel]="vm.marketKeyword()"
        (ngModelChange)="vm.updateMarketKeyword($event)"
        [placeholder]="'assistant.management.store.search.placeholder' | i18n"
        testId="assistant-market-search-input"
      />
    </nz-input-group>
    <button
      nz-button
      type="button"
      class="store-refresh-button"
      [nzLoading]="vm.storeLoading()"
      [disabled]="vm.storeLoading()"
      (click)="vm.refreshAssistantStoreCatalog()"
      testId="assistant-market-refresh-button"
    >
      <i nz-icon nzType="reload" nzTheme="outline"></i>
      {{ 'common.refresh' | i18n }}
    </button>
  </div>

  <nz-spin [nzSpinning]="vm.storeLoading()">
    <div class="store-market-scroll">
      <div class="store-result-count" *ngIf="vm.filteredMarketApps().length > 0">
        {{ 'assistant.management.store.market.count-prefix' | i18n }} {{ vm.filteredMarketApps().length }}
        {{ 'assistant.management.store.market.count-suffix' | i18n }}
      </div>
      <div class="store-catalog-grid" *ngIf="vm.filteredMarketApps().length > 0; else emptyMarket">
        <article class="store-app-card" *ngFor="let app of vm.filteredMarketApps()" [attr.data-testid]="'assistant-market-card-' + app.id">
          <div class="store-app-main">
            <img *ngIf="app.iconUrl; else appIconFallback" class="store-app-icon" [src]="app.iconUrl" [alt]="app.name" />
            <ng-template #appIconFallback
              ><div class="store-app-icon store-app-icon-fallback"><i nz-icon nzType="robot"></i></div
            ></ng-template>
            <div class="store-app-copy">
              <div class="store-app-title-row"
                ><h3>{{ app.name }}</h3
                ><i class="store-verified-icon" nz-icon nzType="check-circle" nzTheme="outline"></i
              ></div>
              <p>{{ app.shortDescription || app.description || ('assistant.management.store.official-assistant' | i18n) }}</p>
              <div class="store-provider">
                <i nz-icon nzType="bank" nzTheme="outline"></i>
                {{ app.providerName || ('assistant.store.provider.official' | i18n) }}
              </div>
            </div>
          </div>
          <div class="store-tags"
            ><span *ngFor="let tag of app.featureTags || []">{{ tag }}</span></div
          >
          <div class="store-app-facts">
            <div
              class="store-app-fact"
              *ngFor="let fact of vm.getStoreCardFacts(app); trackBy: vm.trackByStoreCardFact"
              [attr.title]="fact.label"
            >
              <span class="store-app-fact-icon"><i nz-icon [nzType]="fact.icon" nzTheme="outline" aria-hidden="true"></i></span>
              <span class="store-app-fact-label">{{ fact.label }}</span>
            </div>
          </div>
          <div class="store-app-footer">
            <span class="store-trial-note" *ngIf="vm.shouldShowStoreTrial(app)"
              ><i nz-icon nzType="thunderbolt"></i> {{ 'assistant.management.store.trial.note' | i18n }}</span
            >
            <button
              nz-button
              nzType="primary"
              class="store-detail-button"
              (click)="vm.openAssistantStoreDetail(app)"
              [testId]="'assistant-market-detail-button-' + app.id"
            >
              {{ 'assistant.management.store.action.view-details' | i18n }}
            </button>
          </div>
        </article>
      </div>
      <ng-template #emptyMarket><nz-empty [nzNotFoundContent]="'assistant.management.store.empty.market' | i18n" /></ng-template>
    </div>
  </nz-spin>
</section>

<nz-modal
  [nzVisible]="vm.storeDetailVisible()"
  [nzWidth]="600"
  [nzMaskClosable]="false"
  [nzClosable]="false"
  [nzFooter]="null"
  nzClassName="assistant-store-detail-modal"
  (nzOnCancel)="vm.closeAssistantStoreDetail()"
  testId="assistant-store-detail-modal"
>
  <ng-container *nzModalContent>
    <nz-spin class="store-detail-spin" [nzSpinning]="vm.storeDetailLoading()">
      <div class="store-detail-shell" *ngIf="vm.selectedStoreApp() as app">
        <header class="store-detail-header">
          <div class="store-detail-identity">
            <img *ngIf="app.iconUrl; else detailIconFallback" class="store-detail-icon" [src]="app.iconUrl" [alt]="app.name" />
            <ng-template #detailIconFallback
              ><div class="store-detail-icon store-detail-icon-fallback"><i nz-icon nzType="robot"></i></div
            ></ng-template>
            <div class="store-detail-heading">
              <div class="store-detail-title-row">
                <h2>{{ app.name }}</h2>
                <i class="store-verified-icon" nz-icon nzType="check-circle" nzTheme="outline"></i>
              </div>
              <p>{{ app.shortDescription || app.description }}</p>
            </div>
          </div>
          <button
            type="button"
            class="store-detail-close"
            (click)="vm.closeAssistantStoreDetail()"
            [attr.aria-label]="'common.close' | i18n"
            testId="assistant-market-detail-close-button"
          >
            <i nz-icon nzType="close"></i>
          </button>
        </header>

        <main class="store-detail-body">
          <section class="store-detail-overview-grid">
            <div class="store-detail-summary-card">
              <span>{{ 'assistant.management.store.detail.current-version' | i18n }}</span>
              <strong>v{{ app.version || '-' }}</strong>
            </div>
          </section>

          <section class="store-provider-panel">
            <i nz-icon nzType="bank" nzTheme="outline"></i>
            <div>
              <strong>{{ app.providerName || ('assistant.store.provider.official' | i18n) }}</strong>
              <span>{{ 'assistant.management.store.detail.verified-provider' | i18n }}</span>
            </div>
          </section>

          <section class="store-detail-section store-feature-tags" *ngIf="(app.featureTags || []).length > 0">
            <h3>{{ 'assistant.management.store.detail.feature-tags' | i18n }}</h3>
            <div class="store-tags"
              ><span *ngFor="let tag of app.featureTags || []">{{ tag }}</span></div
            >
          </section>

          <section class="store-detail-section">
            <h3>{{ 'assistant.management.store.detail.configuration' | i18n }}</h3>
            <div class="store-config-grid">
              <div
                ><span>{{ 'assistant.management.store.detail.response-mode' | i18n }}</span
                ><strong>{{ vm.getStoreResponseModeLabel(app.responseMode) }}</strong></div
              >
              <div
                ><span>{{ 'assistant.management.store.detail.message-types' | i18n }}</span
                ><strong>{{ vm.getStoreMessageTypesLabel(app.messageTypes) }}</strong></div
              >
              <div
                ><span>{{ 'assistant.management.store.detail.sender-types' | i18n }}</span
                ><strong>{{ vm.getStoreSenderTypesLabel(app.senderTypes) }}</strong></div
              >
              <div
                ><span>{{ 'assistant.management.store.detail.reply-visibility' | i18n }}</span
                ><strong>{{ vm.getStoreReplyReceiverTypesLabel(app) }}</strong></div
              >
              <div *ngIf="vm.isStoreBatchMode(app)"
                ><span>{{ 'assistant.management.store.detail.trigger-keywords' | i18n }}</span
                ><strong>{{ vm.getStoreTriggerKeywordsLabel(app) }}</strong></div
              >
              <div
                ><span>{{ 'assistant.management.store.detail.duration-options' | i18n }}</span
                ><strong
                  ><ng-container *ngFor="let item of app.durationPackages || []; let last = last"
                    >{{ item.durationDays }} {{ 'assistant.management.store.unit.day' | i18n
                    }}<ng-container *ngIf="!last">、</ng-container></ng-container
                  ></strong
                ></div
              >
            </div>
          </section>

          <section class="store-detail-section">
            <h3>{{ 'assistant.management.store.detail.description' | i18n }}</h3>
            <p class="store-detail-description">{{ app.description || app.shortDescription || '-' }}</p>
          </section>

          <section class="store-detail-section" *ngIf="(app.featureTags || []).length > 0">
            <h3>{{ 'assistant.management.store.detail.core-features' | i18n }}</h3>
            <div class="store-core-features">
              <span *ngFor="let tag of app.featureTags || []"><i nz-icon nzType="check-circle"></i> {{ tag }}</span>
            </div>
          </section>

          <aside class="store-trial-callout" *ngIf="vm.shouldShowStoreTrial(app)">
            <i nz-icon nzType="thunderbolt"></i>
            <div>
              <strong>{{ 'assistant.management.store.detail.trial-title' | i18n }}</strong>
              <p>{{ 'assistant.management.store.detail.trial-description' | i18n }}</p>
            </div>
          </aside>
        </main>

        <footer class="store-detail-footer">
          <button nz-button type="button" (click)="vm.closeAssistantStoreDetail()" testId="assistant-market-detail-cancel-button">{{
            'common.cancel' | i18n
          }}</button>
          <button
            nz-button
            type="button"
            *ngIf="!vm.findStoreSubscription(vm.getStoreTemplateId(app)); else viewStoreInstanceAction"
            [nzLoading]="vm.storeActionLoadingId() === vm.getStoreTemplateId(app)"
            (click)="vm.startSelectedAssistantStoreTrial()"
            testId="assistant-market-detail-trial-button"
          >
            {{ 'assistant.management.store.detail.trial-action' | i18n }}
          </button>
          <ng-template #viewStoreInstanceAction>
            <button
              nz-button
              type="button"
              (click)="vm.openExistingStoreInstance(vm.findStoreSubscription(vm.getStoreTemplateId(app)))"
              testId="assistant-market-detail-view-instance-button"
            >
              {{ 'assistant.management.store.action.view-instance' | i18n }}
            </button>
          </ng-template>
          <ng-container *ngIf="vm.findStoreSubscription(vm.getStoreTemplateId(app)) as subscription; else subscribeStoreAction">
            <ng-container *ngIf="vm.getStoreSubscriptionPowerAction(subscription) as powerAction">
              <button
                nz-button
                nzType="primary"
                type="button"
                *ngIf="powerAction === 'enable'; else stopStoreSubscriptionAction"
                [nzLoading]="vm.storeActionLoadingId() === 'enable-' + subscription.assistantId"
                (click)="vm.enableAssistantStoreSubscription(subscription)"
                testId="assistant-market-detail-enable-button"
              >
                {{ 'assistant.management.action.enable' | i18n }}
              </button>
              <ng-template #stopStoreSubscriptionAction>
                <button
                  nz-button
                  nzDanger
                  type="button"
                  [nzLoading]="vm.storeActionLoadingId() === 'stop-' + subscription.assistantId"
                  (click)="vm.stopAssistantStoreSubscription(subscription)"
                  testId="assistant-market-detail-stop-button"
                >
                  {{ 'assistant.management.store.action.stop' | i18n }}
                </button>
              </ng-template>
            </ng-container>
          </ng-container>
          <ng-template #subscribeStoreAction>
            <button
              nz-button
              nzType="primary"
              type="button"
              class="store-subscribe-button"
              [disabled]="!(vm.selectedStoreApp()?.durationPackages || []).length"
              (click)="vm.openAssistantStorePackageModal()"
              testId="assistant-market-detail-subscribe-button"
            >
              {{ 'assistant.management.store.detail.subscribe-action' | i18n }}
            </button>
          </ng-template>
        </footer>
      </div>
    </nz-spin>
  </ng-container>
</nz-modal>

<nz-modal
  [nzVisible]="vm.storePackageModalVisible()"
  [nzWidth]="'min(1120px, calc(100vw - 32px))'"
  [nzMaskClosable]="false"
  [nzClosable]="false"
  [nzFooter]="null"
  nzClassName="assistant-store-detail-modal assistant-store-package-modal"
  (nzOnCancel)="vm.closeAssistantStorePackageModal()"
  testId="assistant-store-package-modal"
>
  <ng-container *nzModalContent>
    <nz-spin class="store-detail-spin" [nzSpinning]="vm.isStorePackagePaymentLoading()">
      <div class="store-detail-shell store-package-shell" *ngIf="vm.selectedStoreApp() as app">
        <header class="store-detail-header store-package-header">
          <div class="store-package-heading">
            <p>{{ 'assistant.management.store.detail.available-packages' | i18n }}</p>
            <h2>{{ app.name }}</h2>
            <span>{{ app.shortDescription || app.description || ('assistant.management.store.official-assistant' | i18n) }}</span>
          </div>
          <button
            type="button"
            class="store-detail-close"
            (click)="vm.closeAssistantStorePackageModal()"
            [attr.aria-label]="'common.close' | i18n"
            testId="assistant-market-package-close-button"
          >
            <i nz-icon nzType="close"></i>
          </button>
        </header>

        <main class="store-package-layout">
          <section class="store-package-options-panel">
            <div class="store-package-panel-title">{{ 'assistant.management.store.detail.available-packages' | i18n }}</div>
            <div class="store-package-options">
              <button
                type="button"
                class="store-duration-card store-duration-card--purchase"
                *ngFor="let item of app.durationPackages || []"
                [class.is-selected]="vm.selectedStorePackageId() === item.packageId"
                (click)="vm.selectStorePackage(item.packageId)"
                [testId]="'assistant-market-package-option-' + item.packageId"
              >
                <div class="store-duration-card__top">
                  <div class="store-duration-card__title">
                    <strong>{{ item.durationDays }} {{ 'assistant.management.store.unit.day' | i18n }}</strong>
                    <span>{{ vm.formatStorePrice(item.priceCny) }}</span>
                  </div>
                  <small *ngIf="item.recommended">{{ 'assistant.management.store.detail.package.recommended' | i18n }}</small>
                </div>
                <p>{{ vm.getStorePackageHint(item) }}</p>
              </button>
            </div>

            <aside class="store-package-rules">
              <div class="store-package-rules__title">{{ 'assistant.management.store.package.instructions.title' | i18n }}</div>
              <ul>
                <li>{{ 'assistant.management.store.package.instructions.create-order' | i18n }}</li>
                <li>{{ 'assistant.management.store.package.instructions.activate-after-pay' | i18n }}</li>
                <li>{{ 'assistant.management.store.package.instructions.reopen' | i18n }}</li>
              </ul>
            </aside>
          </section>

          <section class="store-package-summary-panel">
            <div class="store-package-summary-title">
              <i nz-icon nzType="credit-card"></i>
              <span>{{ 'assistant.management.store.package.summary.title' | i18n }}</span>
            </div>

            <div class="store-package-balance-card">
              <div class="store-package-balance-head">
                <span>{{ 'assistant.management.store.package.summary.available-uupon' | i18n }}</span>
                <strong>{{ vm.getStorePackageBalancePoints('uupon') }}</strong>
              </div>
              <div class="store-package-balance-row">
                <span>{{ 'assistant.management.store.package.summary.deduct' | i18n }}</span>
                <input
                  class="store-package-balance-input"
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  [disabled]="vm.isStorePackageDeductInputDisabled('uupon')"
                  [ngModel]="vm.deductionInputs.uupon"
                  (beforeinput)="vm.blockNonIntegerInput($event)"
                  (input)="vm.onStorePackageDeductInput('uupon', $event)"
                  placeholder="0"
                  testId="assistant-store-package-uupon-deduct-input"
                />
                <span>{{ 'assistant.management.create.pay.points-unit' | i18n }}</span>
                <a
                  class="store-package-balance-all"
                  [class.is-disabled]="vm.isStorePackageDeductInputDisabled('uupon')"
                  (click)="vm.deductAllStorePackage('uupon')"
                  testId="assistant-store-package-uupon-deduct-all-link"
                  >{{ 'assistant.management.store.package.summary.deduct-all' | i18n }}</a
                >
              </div>
              <div class="store-package-balance-foot">
                <span>{{ 'assistant.management.store.package.summary.deduct-rule' | i18n }}</span>
                <strong>{{ vm.formatStorePrice(vm.getStorePackageDeductedCash('uupon')) }}</strong>
              </div>
            </div>

            <div class="store-package-summary-card" *ngIf="vm.getSelectedStorePackage(app) as selectedPackage">
              <div class="store-package-summary-row">
                <span>{{ 'assistant.management.store.package.summary.duration' | i18n }}</span>
                <strong>{{ selectedPackage.durationDays }} {{ 'assistant.management.store.unit.day' | i18n }}</strong>
              </div>
              <div class="store-package-summary-row">
                <span>{{ 'assistant.management.store.package.summary.product-amount' | i18n }}</span>
                <strong>{{ vm.formatStorePrice(selectedPackage.priceCny) }}</strong>
              </div>
              <div class="store-package-summary-row store-package-summary-row--discount">
                <span>{{ 'assistant.management.store.package.summary.uupon-deduction' | i18n }}</span>
                <strong>-{{ vm.formatStorePrice(vm.getStorePackageDeductedCash('uupon')) }}</strong>
              </div>
              <div class="store-package-summary-row">
                <span>{{ 'assistant.management.store.package.summary.cash-due' | i18n }}</span>
                <strong>{{ vm.formatStorePrice(vm.getStorePackagePayableCash()) }}</strong>
              </div>
              <div class="store-package-summary-divider"></div>
              <div class="store-package-summary-row store-package-summary-row--final">
                <span>{{ 'assistant.management.store.package.summary.final-amount' | i18n }}</span>
                <strong>{{ vm.formatStorePrice(vm.getStorePackagePayableCash()) }}</strong>
              </div>
              <div class="store-package-summary-hint">{{ 'assistant.management.store.package.summary.payment-hint' | i18n }}</div>
            </div>
          </section>
        </main>

        <footer class="store-detail-footer store-package-footer">
          <button nz-button type="button" (click)="vm.closeAssistantStorePackageModal()" testId="assistant-market-package-cancel-button">{{
            'common.cancel' | i18n
          }}</button>
          <button
            nz-button
            nzType="primary"
            type="button"
            class="store-subscribe-button"
            [disabled]="!vm.selectedStorePackageId()"
            [nzLoading]="vm.storeActionLoadingId() === 'purchase-' + vm.selectedStorePackageId()"
            (click)="vm.startSelectedAssistantStorePurchase()"
            testId="assistant-market-package-confirm-pay-button"
          >
            {{ 'assistant.management.create.footer.confirm-pay' | i18n }}
          </button>
        </footer>
      </div>
    </nz-spin>
  </ng-container>
</nz-modal>
